<template>
    <Transition name="slide-left">
        <div
            v-if="isRegionModalActive"
            v-click-outside="() => toggleRegionsList()"
            class="user-regions-question"
        >
            <p class="user-regions-question__title">
                Ваш регион {{ activeRegion.name }}?
            </p>
            <div class="user-regions-question__actions">
                <UIButton
                    label="Да"
                    size="xs"
                    @click="setSelectedRegion(activeRegion)"
                />
                <UIButton
                    label="Выбрать регион"
                    outlined
                    size="xs"
                    class="relative"
                    @click="toggleRegionsList(!isRegionsListVisible)"
                >
                    <template #hint>
                        <UserRegionsList
                            :is-active="isRegionsListVisible"
                            @select="setSelectedRegion"
                        />
                    </template>
                </UIButton>
            </div>
            <UIButton
                flat
                class="popup__close"
                aria-label="Закрытие попапа с регином"
                @click="setSelectedRegion(activeRegion)"
            >
                <CloseSvg />
            </UIButton>
        </div>
    </Transition>
</template>

<script>
import {defineComponent, computed, ref} from 'vue';
import {useContext} from '@nuxtjs/composition-api';
import {UIButton} from '@cibsite/ui-components-vue2';

import {DEFAULT_PARAMS, USER_LOCATION} from '@/core/constants/cookies';
import UserRegionsList from '@/components/UserRegions/UserRegionsList.vue';
import {useRegionsStore} from '@/stores/regions';
import CloseSvg from '@/assets/images/icons/close.svg?inline';

export default defineComponent({
    components: {
        UserRegionsList,
        UIButton,
        CloseSvg,
    },
    setup() {
        const {$cookies, $fetchVisitorLead} = useContext();
        const regionsStore = useRegionsStore();
        const {setUserRegion, toggleRegionModalActivity} = regionsStore;

        const activeRegion = computed(() => regionsStore.activeRegion);
        const isRegionModalActive = computed(() => regionsStore.isRegionModalActive);

        const isRegionsListVisible = ref(false);

        function toggleRegionsList(activity = false) {
            isRegionsListVisible.value = activity;
        }

        function setSelectedRegion(region) {
            $cookies.set(USER_LOCATION, JSON.stringify(region), DEFAULT_PARAMS);
            setUserRegion(region);
            toggleRegionsList(false);
            toggleRegionModalActivity(false);
            $fetchVisitorLead(true);
        }

        return {
            isRegionsListVisible,
            activeRegion,
            isRegionModalActive,
            toggleRegionsList,
            setSelectedRegion,
        };
    },
});
</script>

<style lang="scss">
.user-regions-question {
    position: fixed;
    z-index: 20;
    top: calc(100vh - 95%);
    right: 16px;
    display: flex;
    flex-direction: column;
    padding: 24px 36px;
    background-color: var(--color-primary-70);
    box-shadow: $shadow4;
    border-radius: $radius-6;

    &__close {
        position: absolute;
        top: 12px;
        right: 12px;
    }

    &__title {
        margin-bottom: 24px;
        font-size: 14px;
        color: var(--color-text-0);
    }

    &__actions {
        display: flex;
        align-items: center;
        justify-content: space-between;
        gap: 16px;

        @media screen and (width <= 386px) {
            flex-direction: column;

            button {
                width: 100%;
            }
        }
    }

    @media screen and (width <= 386px) {
        max-width: 100%;
        right: 16px;
        left: 16px;
        padding: 24px 16px 16px;
    }
}

.popup__close {
    position: absolute;
    top: 12px;
    right: 12px;
}
</style>
